module.exports = __webpack_public_path__ + "img/7YW_logo.e49de649.png";